export default "__VITE_PUBLIC_ASSET__673ae91c__"